import type { SellerThreadDetail } from "@recruiter/shared";

// The client + brief, shown in FULL to the talent (the client-side anonymity
// wall hides talents from the client, not the other way round — full disclosure
// in the talent direction is the chosen policy).
export function BriefCard({ thread }: { thread: SellerThreadDetail }) {
  return (
    <div className="sl-brief">
      <div className="sl-brief__eyebrow">Brief from</div>
      <div className="sl-brief__client">{thread.client_name}</div>
      {thread.brief_summary ? (
        <div className="sl-brief__summary">{thread.brief_summary}</div>
      ) : (
        <div className="sl-brief__summary">{thread.subject}</div>
      )}
    </div>
  );
}
